import { useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";

export default function ImageUploadField({ label, value, onChange, testid, hideUrl, uploadedMsg = "Image uploaded" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await onChange(data.url);
      toast.success(uploadedMsg);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Upload failed"); }
    finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className="space-y-1.5">
      {label && <Label className="text-xs text-slate-500">{label}</Label>}
      <div className="flex items-center gap-3">
        {value ? <img src={value} alt="" className="h-12 w-16 shrink-0 rounded-md border border-slate-200 object-cover" data-testid={`${testid}-preview`} /> : <div className="h-12 w-16 shrink-0 rounded-md border border-dashed border-slate-300" />}
        {!hideUrl && <Input value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder="https://… or upload" data-testid={testid} />}
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={upload} data-testid={`${testid}-file`} />
        <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testid}-upload`}>
          <Upload className="mr-1.5 h-4 w-4" /> {busy ? "Uploading…" : value ? "Replace" : "Upload"}
        </Button>
        {value && hideUrl && (
          <Button type="button" variant="ghost" size="sm" className="text-slate-500" onClick={() => onChange("")} data-testid={`${testid}-remove`}><X className="mr-1 h-4 w-4" /> Remove</Button>
        )}
      </div>
    </div>
  );
}
